import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

const PORTAL_ROLES = [
  'school_admin',
  'principal',
  'teacher',
  'receptionist',
  'accountant',
  'librarian',
  'transport_manager',
  'super_admin',
];

/**
 * Allow only authenticated users into the admin portal. Students & guardians
 * (no staff role) are redirected to the app-only notice — the web portal is
 * staff-only; they use the mobile app.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }
  // A super_admin (not impersonating — impersonation swaps identity to the
  // school user) belongs in the platform console, not the school portal.
  if (auth.isSuperAdmin()) {
    return router.createUrlTree(['/platform/dashboard']);
  }
  const roles = auth.currentUser()?.roles ?? [];
  const hasPortalRole = roles.some((r) => PORTAL_ROLES.includes(r));
  return hasPortalRole ? true : router.createUrlTree(['/app-only']);
};
